<template lang='pug'>
  v-dialog(v-model='showAlert', max-width='350px')
    v-card
      v-card-title
      v-card-text.body-2(v-html='message')
      v-card-actions
        v-spacer
        v-btn(color='primary' text @click.stop='close') Close
</template>

<script>
import Notifications from '../services/notification.service';

export default {
  name: 'BionicMetricsAlert',
  components: {},
  methods: {
    alert(message) {
      this.message = message;
      this.showAlert = true;
      // Resolved by closing, so save it off here
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    close() {
      this.showAlert = false;
      this.resolve();
    }
  },
  mounted() {
    Notifications.setAlert(this.alert);
  },
  data() {
    return {
      message: null,
      showAlert: false,
      promise: null
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
